import { i18n } from '@/locales';

const password = {
  message: () => i18n.t('The password must contain one letter, one number, and be at least seven characters long'),
  validate: function(value) {
    return (value.search(/[a-z]/i) > -1)
      && (value.search(/[0-9]/) > -1)
      && (value.length > 6);
  }
}

export default password;

